import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { TRANSLATIONS_ZH } from "./zh/translations";
import { TRANSLATIONS_ZH_HK } from "./zh_HK/translations";
import { TRANSLATIONS_EN } from "./en/translations";
import { TRANSLATIONS_TH } from "./th/translations";
import { TRANSLATIONS_KR } from "./kr/translations";
const FALLBACK_LOCALE = "en";
export default i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: FALLBACK_LOCALE,
    resources: {
      otherLanguages: FALLBACK_LOCALE,
      en: {
        translation: TRANSLATIONS_EN,
      },
      th: {
        translation: TRANSLATIONS_TH,
      },
      zh: {
        translation: TRANSLATIONS_ZH,
      },
      hk: {
        translation: TRANSLATIONS_ZH_HK,
      },
      kr: {
        translation: TRANSLATIONS_KR,
      },
    },
  });

i18n.changeLanguage("en");
